import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    itemContainer: {
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        aspectRatio: 1,
        ...webStyle({
            transition: "all 0.2s ease",
            cursor: "pointer"
        })
    },
    gridContainer: {
        justifyContent: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        flex: 1
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    previewImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        maxHeight: 400
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: "100%"
    },
    headerActions: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth: "100%"
    },
    actionButtonsContainer: {
        position: "absolute",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 10
    },
    headerTitleContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    lightboxCloseButton: {
        position: "absolute",
        zIndex: 10
    },
    itemTitle: {
        textAlign: "center",
        width: "100%"
    },
    modalContentContainer: {
        width: "100%"
    },
    emptyText: {
        textAlign: "center"
    },
    itemWrapper: {
        flexBasis: 320,
        flexShrink: 1,
        flexGrow: 0
    },
    modalCloseButton: {
    },
    previewImage: {
        height: "100%",
        width: "100%"
    },
    searchContainer: {
        minWidth: 250,
        flex: 1
    },
    imagePreview: {
        height: 160,
        width: 160
    }
});

export default stylesheet;
